module.exports = __webpack_public_path__ + "static/media/temperature-low.0f715d5e.svg";